import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom"; // Assuming you're using React Router for routing
import { T1 } from "../../appconfig/texts";

const BackLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState(null);
  
  // Track previous path
  useEffect(() => {
    return () => {
      setPreviousPath(location.pathname);
    };
  }, [location.pathname]);

  const goBack = () => {
    // Check browser history and find a path that has a different base
    const currentBasePath = getBasePath(location.pathname);
    
    // Try to navigate back in history to a different base path
    window.history.go(-1);
    
    // If we can't go back or would go to the same base path, go to dashboard
    setTimeout(() => {
      if (window.location.pathname === location.pathname || 
          getBasePath(window.location.pathname) === currentBasePath) {
        navigate("/dashboard");
      }
    }, 100);
  };
  
  // Helper to get the base path (first segment)
  const getBasePath = (path) => {
    const segments = path.split('/').filter(Boolean);
    return segments.length > 0 ? `/${segments[0]}` : '/';
  };
  
  // Don't render the back button on dashboard or form pages
  if (["/dashboard", "/form"].includes(location.pathname)) return null;
  
  // Don't render if previous path has the same base as current path
  const currentBasePath = getBasePath(location.pathname);
  const prevBasePath = previousPath ? getBasePath(previousPath) : null;
  
  if (prevBasePath && prevBasePath === currentBasePath) return null;
  
  return (
    <Button
      type="text"
      size="small"
      icon={<ArrowLeftOutlined />}
      onClick={goBack}
      className="small-back-link"
    >
      <T1 pos="app.back" />
    </Button>
  );
};

export default BackLink;
